import { Grid } from '@mui/material';
import { useForm, useFormContext } from 'react-hook-form';
import RHFTextField from '../../Components/RHFTextField';
import RHFSelect from '../../Components/RHFSelect';
import Country from '../../../CompanycodeTranslation/components/country';
import State from '../../../CompanycodeTranslation/components/state';
import { useEffect, useRef, useState } from 'react';
import { useLazyGetCountryAndStateOptionsQuery, useLazyGetDistrictOptionsQuery } from '../../../CompanycodeTranslation/Api/countryApi';
import { Options } from '../../../CompanycodeTranslation/types';

const Step1Address = () => {
  const { watch } = useFormContext();
  const [statesLists, setstatesLists] = useState<Options[]>([]);
  const stateref = useRef(null);
  const { setValue } = useForm();
  const values = watch(['state']);
  console.log(values, 'bbbbbbbbbbb');
  const [statefn] = useLazyGetCountryAndStateOptionsQuery();

  const handleStateChange = (option: any, val: any) => {
    console.log(option, val, 'kkkkkkkkkkkkkk');

    setValue('state', val.value);
  };

  useEffect(() => {
    const stateFetch = async () => {
      const data = await statefn({ codetype: 'IndiaState' }, true);
      console.log(data, 'data');
      setstatesLists(data.data || []);
    };
    stateFetch();
  }, []);
  const selectedState = watch('state'); // 👈 watch state field
  const [districtOptions, setDistrictOptions] = useState<Options[]>([]);

  const [getDistrictOptions] = useLazyGetDistrictOptionsQuery();
  // Fetch district list when state changes
  useEffect(() => {
    if (!selectedState) return;

    // Reset district field
    setValue('district', '');

    const fetchDistricts = async () => {
      try {
        const districtResponse = await getDistrictOptions({ codetype: selectedState });
        if (districtResponse.data) {
          setDistrictOptions(districtResponse.data);
        }
      } catch (err) {
        console.error('Error fetching districts:', err);
        setDistrictOptions([]);
      }
    };

    fetchDistricts();
  }, [selectedState, setValue]);
  return (
    <Grid container spacing={2} sx={{ mt: 4 }}>
      <Grid item xs={12}>
        <h3>Address Info</h3>
      </Grid>

      <Grid item xs={4}>
        <Country name="Country" size="small" label="Country" value="IndiaState" disabled={true} />
      </Grid>

      <Grid item xs={4}>
        <RHFTextField name="pincode" label="Pincode" />
      </Grid>

      <Grid item xs={4}>
        <RHFSelect name="state" label="State" options={statesLists} />
      </Grid>

      <Grid item xs={4}>
        <RHFTextField name="city" label="City" />
      </Grid>

      <Grid item xs={4}>
        <RHFSelect name="district" label="District" options={districtOptions} />
      </Grid>

      <Grid item xs={4}>
        <RHFTextField name="businessAddress" label="Business Address" multiline rows={4} />
      </Grid>
    </Grid>
  );
};

export default Step1Address;
